import { DpMarkIco } from '@/components/blocks/DpLibrary/DpMark/parts/DpMarkIco';
import { titleMarkSX } from '@/components/blocks/DpLibrary/DpMark/style/typography';
import { Grid, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { useContext } from 'react';
import { MarksSliderContext } from '@/data/context/content';

export const DpMark = ({
	title,
	image,
	href,
	alt,
	loading,
	priority,
}: {
	title: string;
	image: string;
	href?: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
}) => {
	const { mouseMoved } = useContext(MarksSliderContext);

	return (
		<Linkable
			href={href}
			draggable="false"
			// onMouseDown={(e: React.MouseEvent<HTMLAnchorElement>) => e.preventDefault()} TODO: check if this is needed
			onClick={(e: React.MouseEvent<HTMLAnchorElement>) => mouseMoved && e.preventDefault()}
		>
			<Grid
				sx={{
					width: '100%',
					userSelect: 'none',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<DpMarkIco image={image} loading={loading} priority={priority} alt={alt ?? title} />
				<Typography component="li" sx={titleMarkSX}>
					{title}
				</Typography>
			</Grid>
		</Linkable>
	);
};
